<template>
    <div class="w-100 mt-2">
        <div
            v-if   = "!editable"
            class  = "escalator-note"
            :style = "'max-height: ' + (rows * 24) + 'px'"
            v-html = "html"
        />
        <v-textarea
            v-else
            v-model     = "data.note"
            :label      = "$t('unit.escalator.tzb.note')"
            :rows       = "rows"
            maxlength   = "4000"
            class       = "pt-1"
            hide-details
            no-resize
        />
    </div>
</template>

<script>

import Escalator from "@/modules/msd/unit/service/Escalator";

/**
 * The LM4-only note of an escalator TZB, its maintenance or a component (HCIT-937). Notes are shown as text (escaped,
 * line breaks kept) and can be edited on the latest TZB only.
 */
export default {
    name: "CSiteTzbEscalatorNote",

    props: {
        data: {
            required: true,
            type    : Object
        },

        editable: {
            type   : Boolean,
            default: false
        },

        rows: {
            type   : Number,
            default: 2
        }
    },

    computed: {
        html () {
            return Escalator.noteHtml(this.data.note);
        }
    }
}
</script>

<style scoped>

.escalator-note {
    overflow-y: auto;
    font-size: 14px;
}

</style>
